












































































































































import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import api from "../honcierge-api"
import { AxiosError } from "axios"
import SelectedSpecialFeaturesDialog from "@/components/Category/SelectedSpecialFeaturesDialog.vue"
import { BannerType, Category, Image, SpecialFeature } from "types/index"
import { mapState } from "vuex"
import { DataTableHeader } from "vuetify/types"

@Component({
  components: { SelectedSpecialFeaturesDialog },
  computed: {
    ...mapState("master", ["bannerTypes"]),
  },
})
export default class EditCategory extends Vue {
  @Prop()
  private dialog!: boolean

  private showSelectDialog = false

  public id = -1 // 正なら新規作成, そうでないなら更新処理を行う
  public name = ""
  public isEnabled = false
  public urlKey = ""
  public priority = -1
  public selectedSpecialFeatures: SpecialFeature["view"][] = []
  public bannerType: BannerType = { id: 0, name: "未指定", value: "" }

  private pagination = {
    sortBy: ["priority"],
    sortDesc: [true],
  }

  // rules for form
  private nameRules = [(name: string) => !!name || "ユーザ名は必須です"]
  private urlRules = [(urlKey: string) => !!urlKey || "URLは必須です"]
  private priorityRules = [
    (priority: number) => !!priority || "優先度は必須です",
  ]
  private priorityOfSpecialFeatureRule = [
    (priority: number) => !!priority || "優先度は必須です",
  ]

  get headers(): DataTableHeader[] {
    return [
      { text: "優先度", value: "priority" },
      { text: "タイトル", value: "title" },
      { text: "概要", value: "overview" },
      { text: "バナー", value: "banner", sortable: false },
      { text: "操作", value: "aciton", sortable: false },
    ]
  }

  public updateCategory(): void {
    if (!this.validate()) {
      return
    }
    api
      .updateCategory({
        id: this.id,
        name: this.name,
        urlKey: this.urlKey,
        priority: this.priority,
        isEnabled: this.isEnabled,
        bannerTypeId: this.bannerType.id,
        specialFeatures: this.selectedSpecialFeatures,
      })
      .then((res) => {
        this.emitCategory(res.data.category)
        this.$toasted.success("カテゴリーを更新しました")
      })
      .catch((e: AxiosError) => {
        if (e.response) {
          this.$toasted.error(e.response.data.messages)
        }
      })
  }

  public createCategory(): void {
    if (!this.validate()) {
      return
    }
    api
      .createCategory({
        name: this.name,
        isEnabled: this.isEnabled,
        urlKey: this.urlKey,
        priority: this.priority,
        bannerTypeId: this.bannerType.id,
        specialFeatures: this.selectedSpecialFeatures,
      })
      .then((res) => {
        this.emitCategory(res.data.category)
        this.$toasted.success("カテゴリーを新規作成しました")
      })
      .catch((e: AxiosError) => {
        if (e.response) {
          this.$toasted.error(e.response.data.messages)
        }
      })
  }

  @Emit("emitCategory")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitCategory(category: Category["view"]) {
    this.close()
  }

  @Emit("close")
  private close() {
    this.clear()
  }

  private validate(): boolean {
    const form = this.$refs.form as InstanceType<typeof EditCategory>
    return form.validate()
  }

  private resetValidation(): void {
    const form = this.$refs.form as InstanceType<typeof EditCategory>
    return form.resetValidation()
  }

  private clear() {
    this.init()
    this.resetValidation()
  }

  private init() {
    this.id = -1
    this.name = ""
    this.isEnabled = false
    this.priority = -1
    this.urlKey = ""
    this.selectedSpecialFeatures = []
    if (Array.isArray(this.$store.state.master.bannerTypes)) {
      this.bannerType = this.$store.state.master.bannerTypes[0]
    }
  }

  private ok(specialFeatures: SpecialFeature["view"][]) {
    this.closeSelectedSpecialFeaturesDialog()
    specialFeatures.forEach((specialFeature) =>
      this.selectedSpecialFeatures.push(specialFeature)
    )
  }

  private cancel() {
    this.closeSelectedSpecialFeaturesDialog()
  }

  private openSelectedSpecialFeaturesDialog() {
    const selectedSpecialFeaturesDialog = this.$refs
      .selectedSpecialFeaturesDialog as InstanceType<
      typeof SelectedSpecialFeaturesDialog
    >
    selectedSpecialFeaturesDialog.clear()
    selectedSpecialFeaturesDialog.search()
    this.showSelectDialog = true
  }

  private closeSelectedSpecialFeaturesDialog() {
    this.showSelectDialog = false
    const selectedSpecialFeaturesDialog = this.$refs
      .selectedSpecialFeaturesDialog as InstanceType<
      typeof SelectedSpecialFeaturesDialog
    >
    selectedSpecialFeaturesDialog.clear()
  }

  private remove(priority: number) {
    const index = this.selectedSpecialFeatures.findIndex(
      (specialFeature) => specialFeature.priority === priority
    )
    this.selectedSpecialFeatures.splice(index, 1)
  }

  private existBanner(banner: Image): boolean {
    return banner.filename !== null && banner.url !== null
  }
}
